import {useCallback, useContext} from 'react';
import {OAuthManagerContext} from "../component/azure/context";

const EXPLICIT_SIGNED_OUT_INDICATOR = "explicit-signed-out-indicator";
const hasExplicitlySignedOut = (): boolean => {
    return localStorage.getItem(EXPLICIT_SIGNED_OUT_INDICATOR) === "true";
}

export const useAuthentication = () => {
    const oauthManager = useContext(OAuthManagerContext);

    const signOut = useCallback(async () => {
        await oauthManager?.clearToken();
        localStorage.setItem(EXPLICIT_SIGNED_OUT_INDICATOR, "true");
        window.location.reload();
    }, [oauthManager]);

    const signIn = useCallback(() => {
        localStorage.removeItem(EXPLICIT_SIGNED_OUT_INDICATOR);
        window.location.href = oauthManager?.loginUrl(btoa(JSON.stringify({
            successUri: window.location.href.replace(window.location.origin, '')
        }))) ?? '/';
    }, [oauthManager]);

    return {
        hasExplicitlySignedOut,
        signOut,
        signIn,
    }
};
